import type { PluginFunc, QUnitType, UnitType } from 'dayjs/esm'

declare module 'dayjs/esm' {
  interface Dayjs {
    roundNearest(unit: QUnitType): Dayjs
  }
}

/**
 * Add the function of "roundNearest" to dayjs
 * See: https://github.com/iamkun/dayjs/issues/1619
 */
const roundNearest: PluginFunc = (_o, c) => {
  const proto = c.prototype
  proto.roundNearest = function (unit) {
    // default case: round to nearest day
    let subUnit: UnitType = 'hours'
    let amount = 24

    // round to nearest hour
    if (unit === 'hour') {
      subUnit = 'minutes'
      amount = 60
    }

    const mod = this.get(subUnit) % amount

    // round down
    if (mod < amount / 2) {
      return this.subtract(mod, subUnit).startOf(subUnit)
    }

    // round up
    return this.add(amount - mod, subUnit).startOf(subUnit)
  }
}

export default roundNearest
